import React, { useRef, useEffect, useState } from "react";
import mapboxgl from "mapbox-gl";
import MapboxGeocoder from "@mapbox/mapbox-gl-geocoder";
import "@mapbox/mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css"; // Official Mapbox Geocoder CSS
import { BACKEND_URL } from "../../environment";
import axios from "axios";
import { useSelector } from "react-redux";
import "mapbox-gl/dist/mapbox-gl.css";
import { FaBolt, FaHome, FaUsers, FaFire } from "react-icons/fa";
import { LuCircleDashed } from "react-icons/lu";
import { TbChartPie } from "react-icons/tb";
import { CgShapeZigzag } from "react-icons/cg";
import { GoArrowRight } from "react-icons/go";
import { Chart } from "primereact/chart";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";

import "./MappingPage.css";
mapboxgl.accessToken =
  "pk.eyJ1IjoiZ2VvdGhhcmEiLCJhIjoiY2xrd21tb2VpMTJ0djNybXliZzhwb29hOCJ9.3hVMlLmgoVu8cOPEH5IsYg";

function MappingPage(props) {
  const mapContainer = useRef(null);
  const map = useRef(null);

  // Use shared location from props
  const { sharedLocation, setSharedLocation } = props;

  // We can keep selectDataType as local state
  const [selectDataType, setSelectDataType] = useState("admins");
  const [downloadingMapData, setDownloadingMapData] = useState(false);
  const [buttonTextDownload, setButtonTextDownload] = useState("Download");
  const [activeIcon, setActiveIcon] = useState("energy");
  const [climateData, setClimateData] = useState(null);
  const [showClimateDialog, setShowClimateDialog] = useState(false);

  const { userData } = useSelector((state) => state.authReducer);

  // Add new state for tooltips if needed
  const [activeTooltip, setActiveTooltip] = useState(null);

  useEffect(() => {
    if (map.current) return;

    // Initialize map with shared location coordinates
    const initialCoords = sharedLocation?.coordinates || [-74.006, 40.7128];

    const newMap = new mapboxgl.Map({
      container: mapContainer.current,
      style: "mapbox://styles/mapbox/light-v10",
      center: initialCoords,
      zoom: 12,
    });

    const geocoder = new MapboxGeocoder({
      accessToken: mapboxgl.accessToken,
      mapboxgl: mapboxgl,
      marker: false,
      position: "top-left",
    });

    // Add controls to the map
    // ... (rest of the control code)

    // Add controls to the map
    // newMap.addControl(new mapboxgl.NavigationControl()); // Add navigation controls
    newMap.addControl(geocoder, "top-right");
    // newMap.addControl(new mapboxgl.NavigationControl(), "top-right");
    // newMap.addControl(
    //   new mapboxgl.FullscreenControl(
    //     {
    //       position: "bottom-right",
    //     },
    //     "bottom-right"
    //   )
    // );
    newMap.addControl(
      new mapboxgl.NavigationControl(
        {
          showCompass: true,
          showZoom: true,
          visualizePitch: true,
        },
        "bottom-right"
      )
    );
    // newMap.addControl(new mapboxgl.NavigationControl());

    map.current = newMap;

    // Add event listener to geocoder to update shared location
    geocoder.on("result", (event) => {
      const result = event.result;
      setSharedLocation({
        label: result.place_name,
        coordinates: result.center,
        placeDetails: result,
      });
    });

    // Load climate data from localStorage if available
    const storedClimateData = localStorage.getItem("climateData");
    if (storedClimateData) {
      setClimateData(JSON.parse(storedClimateData));

      // Check if we should show the dialog (flag set by DataTrendPage)
      const shouldShowDialog = localStorage.getItem("showClimateDialog");
      if (shouldShowDialog === "true") {
        // Clear the flag
        localStorage.removeItem("showClimateDialog");

        // Use setTimeout to ensure the component is fully mounted
        setTimeout(() => {
          setShowClimateDialog(true);
        }, 500);
      }
    }
  }, [sharedLocation]);

  // Update map when shared location changes
  useEffect(() => {
    if (map.current && sharedLocation.coordinates) {
      map.current.flyTo({
        center: sharedLocation.coordinates,
        zoom: 12,
        essential: true,
      });
    }
  }, [sharedLocation]);

  // Modify handleCountryChange to update shared location
  const handleCountryChange = (event) => {
    const selectedCity = event.target.value;
    let coordinates = [-74.006, 40.7128]; // Default to NYC

    // Get coordinates based on city
    if (selectedCity === "Seattle") {
      coordinates = [-122.3321, 47.6062];
    } else if (selectedCity === "Chicago") {
      coordinates = [-87.6298, 41.8781];
    } else if (selectedCity === "New York City") {
      coordinates = [-74.006, 40.7128];
    } else if (selectedCity === "Ooty") {
      coordinates = [76.6932, 11.4069];
    } else if (selectedCity === "Bangalore") {
      coordinates = [77.5946, 12.9716];
    }

    // Update shared location
    setSharedLocation({
      label: selectedCity,
      coordinates: coordinates,
      placeDetails: null,
    });
  };

  // function addGeoPackageLayersToMap(mapInstance) {
  //   const sourceId = "geopackage-source";

  //   // Check if the source already exists
  //   if (!mapInstance.getSource(sourceId)) {
  //     const geoPackageUrl = "/data_buildings.gpkg";
  //     mapInstance.addSource(sourceId, {
  //       type: "vector",
  //       url: geoPackageUrl,
  //     });

  //     mapInstance.addLayer({
  //       id: "geopackage-layer",
  //       type: "circle", // Use the appropriate layer type
  //       source: sourceId,
  //       "source-layer": "YOUR_SOURCE_LAYER_NAME", // Replace with the source layer name from your GeoPackage
  //       paint: {
  //         "circle-radius": 6,
  //         "circle-color": "#FF0000",
  //       },
  //     });
  //   }
  // }

  const handleDownloadingMapData = (e) => {
    e.preventDefault();

    setButtonTextDownload("Downloading, Please Wait...");

    if (sharedLocation.label === "New York City") {
      // if (
      //   selectCountry === "New York City" &&
      //   buttonTextDownload !== "Download"
      // ) {
      let layerName;
      let color;
      if (selectDataType === "admins") {
        layerName = "/assets/data_admins_NYC_10000.geojson";
        color = "yellow";
      } else if (selectDataType === "buildings") {
        layerName = "/assets/data_buildings_NYC_10000.geojson";
        color = "red";
      } else if (selectDataType === "places") {
        layerName = "/assets/data_places_NYC_10000.geojson";
        color = "green";
      } else if (selectDataType === "transportation") {
        layerName = "/assets/data_transportation_NYC_10000.geojson";
        color = "blue";
      }
      // Perform the download action without axios
      const url = layerName; // Replace with your file URL
      const a = document.createElement("a");
      a.href = url;
      a.download = `${sharedLocation.label}_${selectDataType}.geojson`; // Set the desired filename
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);

      addGeoPackageLayersToMap(
        map.current,
        `geopackage-source-${selectDataType}`,
        layerName,
        color
      );

      setButtonTextDownload("Download");

      return;
    }

    const formData = new FormData();
    formData.append("city", sharedLocation.label);
    formData.append("dataType", selectDataType);

    const config = {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${userData.token}`,
      },
    };

    axios
      .post(`${BACKEND_URL}download_mapData/`, formData, config) // Replace with your actual API endpoint
      .then((response) => {
        // Create a Blob from the response data
        const blob = new Blob([response.data], { type: "application/gpkg" });

        // Create a download link and trigger the download
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `data_${selectDataType}.gpkg`; // Set the desired filename
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);

        setButtonTextDownload("Download");
      })
      .catch((error) => {
        setButtonTextDownload(error?.response?.data?.message);
        setTimeout(() => {
          setButtonTextDownload("Download");
        }, 3000);
      });
  };

  function addGeoPackageLayersToMap(mapInstance, sourceId, layerName, color) {
    if (!mapInstance.getSource(sourceId)) {
      const layers = mapInstance.getStyle().layers;
      // Find the index of the first symbol layer in the map style.
      let firstSymbolId;
      for (const layer of layers) {
        if (layer.type === "symbol") {
          firstSymbolId = layer.id;
          break;
        }
      }
      mapInstance.addSource(sourceId, {
        type: "geojson",
        data: layerName,
      });
      mapInstance.addLayer(
        {
          id: sourceId,
          type: "fill",
          source: sourceId,
          layout: {},
          paint: {
            "fill-color": color,
            // "fill-color": "#f08",
            "fill-opacity": 0.4,
          },
        },
        firstSymbolId
      );
    }
  }

  // Add this function to prepare chart data
  const prepareChartData = (dataset, title, color) => {
    if (!dataset || !dataset.yearly_averages) return null;

    const years = dataset.yearly_averages.years;
    const values = dataset.yearly_averages.values;

    return {
      labels: years,
      datasets: [
        {
          label: title,
          data: values,
          fill: false,
          borderColor: color,
          tension: 0.4,
        },
      ],
    };
  };

  // Add chart options
  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "top",
      },
      title: {
        display: true,
        text: "Climate Data Trends",
      },
    },
    scales: {
      y: {
        beginAtZero: false,
      },
    },
  };

  // Modify the showClimateDataDialog function to also fly to the location
  const showClimateDataDialog = () => {
    if (climateData) {
      map.current.flyTo({
        center: sharedLocation.coordinates,
        zoom: 12,
        essential: true,
      });
      setShowClimateDialog(true);
    } else {
      alert(
        "No climate data available. Please retrieve climate data from the Data tab first."
      );
    }
  };

  // Add a helper function to remove fire layers
  const removeFireLayers = () => {
    if (map.current) {
      if (map.current.getLayer("fire-regions")) {
        map.current.removeLayer("fire-regions");
      }
      if (map.current.getLayer("fire-regions-outline")) {
        map.current.removeLayer("fire-regions-outline");
      }
      if (map.current.getSource("fire-regions-source")) {
        map.current.removeSource("fire-regions-source");
      }

      // Remove event listeners
      map.current.off("mouseenter", "fire-regions");
      map.current.off("mouseleave", "fire-regions");
    }
  };

  // Add these handler functions inside your MappingPage component
  const handleFireClick = () => {
    setActiveIcon("fire");

    // Create a GeoJSON with multiple fire point markers around Eaton Canyon area
    // Using accurate coordinates based on the screenshot for Pasadena/Eaton fire area
    const eatonFireData = {
      type: "FeatureCollection",
      features: [
        // Main Eaton fire - labeled specifically (placing it at the right location based on screenshot)
        {
          type: "Feature",
          properties: {
            name: "Eaton fire",
            severity: "Critical",
            isMainFire: true,
          },
          geometry: {
            type: "Point",
            coordinates: [-118.055, 34.175], // Corrected Eaton fire location from screenshot
          },
        },
        // Generate multiple fire points in the area
        // Altadena/North Pasadena cluster - corrected coordinates based on screenshot
        ...[
          [-118.167, 34.177],
          [-118.162, 34.182],
          [-118.157, 34.179],
          [-118.152, 34.176],
          [-118.158, 34.172],
          [-118.163, 34.171],
          [-118.168, 34.17],
          [-118.173, 34.168],
          [-118.165, 34.166],
          [-118.16, 34.168],
          [-118.155, 34.171],
          [-118.151, 34.173],
          [-118.148, 34.175],
          [-118.146, 34.178],
          [-118.144, 34.181],
          [-118.15, 34.183],
          [-118.155, 34.18],
          [-118.157, 34.175],
          [-118.161, 34.174],
          [-118.169, 34.175],
          [-118.175, 34.173],
          [-118.147, 34.169],
          [-118.145, 34.172],
          [-118.152, 34.168],
        ].map((coords, index) => ({
          type: "Feature",
          properties: {
            name: `Fire point ${index + 1}`,
            severity:
              Math.random() > 0.7
                ? "High"
                : Math.random() > 0.5
                ? "Moderate"
                : "Low",
          },
          geometry: {
            type: "Point",
            coordinates: coords,
          },
        })),
        // Eastern cluster / Eaton area - corrected coordinates based on screenshot
        ...[
          [-118.035, 34.165],
          [-118.04, 34.17],
          [-118.045, 34.175],
          [-118.05, 34.18],
          [-118.055, 34.185],
          [-118.06, 34.19],
          [-118.065, 34.185],
          [-118.07, 34.18],
          [-118.075, 34.175],
          [-118.08, 34.17],
          [-118.085, 34.175],
          [-118.09, 34.18],
          [-118.095, 34.175],
          [-118.1, 34.17],
          [-118.105, 34.165],
          [-118.03, 34.17],
          [-118.025, 34.175],
          [-118.02, 34.18],
          [-118.015, 34.175],
          [-118.01, 34.17],
          [-118.005, 34.165],
        ].map((coords, index) => ({
          type: "Feature",
          properties: {
            name: `Fire point E${index + 1}`,
            severity:
              Math.random() > 0.6
                ? "High"
                : Math.random() > 0.4
                ? "Moderate"
                : "Low",
          },
          geometry: {
            type: "Point",
            coordinates: coords,
          },
        })),
      ],
    };

    // Add fire regions to the map
    if (map.current) {
      // First, remove existing fire layers if they exist
      removeFireLayers();

      // Remove any existing HTML markers from previous fire display
      const existingMarkers = document.querySelectorAll(
        ".fire-marker, .fire-marker-main"
      );
      existingMarkers.forEach((el) => {
        if (el.parentNode) el.parentNode.removeChild(el);
      });

      // Add new fire regions source
      map.current.addSource("fire-regions-source", {
        type: "geojson",
        data: eatonFireData,
      });

      // Add more reliable SVG fire markers instead of text emoji
      map.current.addLayer({
        id: "fire-regions",
        type: "symbol",
        source: "fire-regions-source",
        layout: {
          "icon-image": "fire-station-15", // Mapbox's built-in fire icon as base
          "icon-size": [
            "case",
            ["==", ["get", "isMainFire"], true],
            2.2, // Larger for main fire
            1.6, // Regular size for other fires
          ],
          "icon-allow-overlap": true,
          "text-field": [
            "case",
            ["==", ["get", "isMainFire"], true],
            ["get", "name"],
            "",
          ],
          "text-font": ["Open Sans Semibold", "Arial Unicode MS Bold"],
          "text-offset": [1.2, 0], // Position text to the right of the icon
          "text-anchor": "left",
          "text-size": 12,
        },
        paint: {
          "text-color": "#ff3300",
          "text-halo-color": "rgba(255, 255, 255, 0.8)",
          "text-halo-width": 1.5,
        },
      });

      // Add a click handler for the fire points
      map.current.on("click", "fire-regions", (e) => {
        if (!e.features || e.features.length === 0) return;

        const feature = e.features[0];
        const coordinates = feature.geometry.coordinates.slice();

        // Create popup content
        const { name, severity } = feature.properties;
        const content = `
          <h4>${name}</h4>
          <p><strong>Severity:</strong> ${severity}</p>
        `;

        // Create and show the popup
        new mapboxgl.Popup()
          .setLngLat(coordinates)
          .setHTML(content)
          .addTo(map.current);
      });

      // Change cursor on hover
      map.current.on("mouseenter", "fire-regions", () => {
        map.current.getCanvas().style.cursor = "pointer";
      });

      map.current.on("mouseleave", "fire-regions", () => {
        map.current.getCanvas().style.cursor = "";
      });

      // Center map correctly - coordinates based on screenshot
      map.current.flyTo({
        center: [-118.1, 34.17], // Center between Pasadena and Eaton fire areas
        zoom: 12, // Better zoom level to see all fire points
        essential: true,
      });
    }
  };

  const handleTemperatureClick = () => {
    setActiveIcon("temperature");
    // Remove fire layers when switching to temperature
    removeFireLayers();
    // Show temperature data visualization
    if (climateData && climateData.temperature) {
      showClimateDataWithFocus("temperature");
    } else {
      alert(
        "Temperature data not available. Please retrieve climate data first."
      );
    }
  };

  const handleDTRClick = () => {
    setActiveIcon("dtr");
    // Remove fire layers when switching to DTR
    removeFireLayers();
    // Show DTR data visualization
    if (climateData && climateData.diurnal_temp_range) {
      showClimateDataWithFocus("dtr");
    } else {
      alert(
        "Diurnal Temperature Range data not available. Please retrieve climate data first."
      );
    }
  };

  const handleVaporClick = () => {
    setActiveIcon("vapor");
    // Remove fire layers when switching to vapor
    removeFireLayers();
    // Show vapor pressure data visualization
    if (climateData && climateData.vapor_pressure) {
      showClimateDataWithFocus("vapor");
    } else {
      alert(
        "Vapor Pressure data not available. Please retrieve climate data first."
      );
    }
  };

  const handlePrecipitationClick = () => {
    setActiveIcon("precipitation");
    // Remove fire layers when switching to precipitation
    removeFireLayers();
    // Show precipitation data visualization
    if (climateData && climateData.precipitation) {
      showClimateDataWithFocus("precipitation");
    } else {
      alert(
        "Precipitation data not available. Please retrieve climate data first."
      );
    }
  };

  // Function to show climate data dialog with a specific section focused
  const showClimateDataWithFocus = (dataType) => {
    setShowClimateDialog(true);
    // You could potentially scroll to the specific chart section here
    // or highlight the relevant section
  };

  return (
    <div style={{ display: "flex" }}>
      <Dialog
        header="Climate Data Analysis"
        visible={showClimateDialog}
        style={{ width: "80vw" }}
        onHide={() => setShowClimateDialog(false)}
      >
        {climateData && (
          <div className="grid">
            <div className="col-12 md:col-6">
              <h3>Temperature</h3>
              <Chart
                type="line"
                data={prepareChartData(
                  climateData.temperature,
                  "Temperature (°C)",
                  "#FF6384"
                )}
                options={chartOptions}
                style={{ height: "300px" }}
              />
            </div>
            <div className="col-12 md:col-6">
              <h3>Diurnal Temperature Range</h3>
              <Chart
                type="line"
                data={prepareChartData(
                  climateData.diurnal_temp_range,
                  "Diurnal Temp Range (°C)",
                  "#36A2EB"
                )}
                options={chartOptions}
                style={{ height: "300px" }}
              />
            </div>
            <div className="col-12 md:col-6">
              <h3>Precipitation</h3>
              <Chart
                type="line"
                data={prepareChartData(
                  climateData.precipitation,
                  "Precipitation (mm/month)",
                  "#4BC0C0"
                )}
                options={chartOptions}
                style={{ height: "300px" }}
              />
            </div>
            <div className="col-12 md:col-6">
              <h3>Vapor Pressure</h3>
              <Chart
                type="line"
                data={prepareChartData(
                  climateData.vapor_pressure,
                  "Vapour Pressure (hPa)",
                  "#9966FF"
                )}
                options={chartOptions}
                style={{ height: "300px" }}
              />
            </div>
            <div className="col-12">
              <h3>Location</h3>
              <p>Coordinates: {sharedLocation.coordinates.join(", ")}</p>
            </div>
          </div>
        )}
      </Dialog>
      <div className="map-sidebar">
        <div
          className={`sidebar-icon ${activeIcon === "energy" ? "active" : ""}`}
          onClick={() => {
            setActiveIcon("energy");
          }}
          title="Energy"
        >
          <FaBolt />
        </div>

        {/* Climate data icons with tooltips */}
        <div
          className={`sidebar-icon ${activeIcon === "fire" ? "active" : ""}`}
          onClick={handleFireClick}
          title="Fire"
        >
          <FaFire
            style={{ color: activeIcon === "fire" ? "white" : "#ff5722" }}
          />
        </div>

        <div
          className={`sidebar-icon ${
            activeIcon === "temperature" ? "active" : ""
          }`}
          onClick={handleTemperatureClick}
          title="Temperature (T)"
        >
          <i
            className="pi pi-sun"
            style={{
              color: activeIcon === "temperature" ? "white" : "#ff9800",
            }}
          ></i>
        </div>

        <div
          className={`sidebar-icon ${activeIcon === "dtr" ? "active" : ""}`}
          onClick={handleDTRClick}
          title="Diurnal Temperature Range (DTR)"
        >
          <div
            style={{
              fontSize: "14px",
              fontWeight: "bold",
              color: activeIcon === "dtr" ? "white" : "#36A2EB",
            }}
          >
            DTR
          </div>
        </div>

        <div
          className={`sidebar-icon ${activeIcon === "vapor" ? "active" : ""}`}
          onClick={handleVaporClick}
          title="Vapor Pressure (VP)"
        >
          <i
            className="pi pi-cloud"
            style={{ color: activeIcon === "vapor" ? "white" : "#9966FF" }}
          ></i>
        </div>

        <div
          className={`sidebar-icon ${
            activeIcon === "precipitation" ? "active" : ""
          }`}
          onClick={handlePrecipitationClick}
          title="Precipitation"
        >
          <i
            className="pi pi-cloud-download"
            style={{
              color: activeIcon === "precipitation" ? "white" : "#4BC0C0",
            }}
          ></i>
        </div>

        {/* <div
          className={`sidebar-icon ${activeIcon === "stats" ? "active" : ""}`}
          onClick={() => {
            setActiveIcon("stats");
          }}
          title="Statistics"
        >
          <LuCircleDashed />
        </div>
        <div
          className={`sidebar-icon ${activeIcon === "pie" ? "active" : ""}`}
          onClick={() => {
            setActiveIcon("pie");
          }}
          title="Chart"
        >
          <TbChartPie />
        </div>
        <div
          className={`sidebar-icon ${activeIcon === "route" ? "active" : ""}`}
          onClick={() => {
            setActiveIcon("route");
          }}
        >
          <CgShapeZigzag />
        </div>
        <div
          className={`sidebar-icon ${
            activeIcon === "go-right" ? "active" : ""
          }`}
          onClick={() => {
            setActiveIcon("go-right");
          }}
        >
          <GoArrowRight />
        </div>
        <div
          className={`sidebar-icon ${activeIcon === "home" ? "active" : ""}`}
          onClick={() => {
            setActiveIcon("home");
          }}
        >
          <FaHome />
        </div>
        <div
          className={`sidebar-icon ${activeIcon === "users" ? "active" : ""}`}
          onClick={() => {
            setActiveIcon("users");
          }}
        >
          <FaUsers />
        </div>
        <div
          className={`sidebar-icon ${activeIcon === "climate" ? "active" : ""}`}
          onClick={() => {
            showClimateDataDialog();
            setActiveIcon("climate");
          }}
        >
          <i className="pi pi-chart-line"></i>
        </div> */}
      </div>
      <div className="map-main-div bg-white">
        {/* {loading ? (
          <LoadingSpinner />
        ) : (
          <> */}
        <div className="select-country-maindiv">
          <select
            className="select-country-box"
            value={sharedLocation?.label || "New York City"}
            onChange={handleCountryChange}
          >
            <option value="New York City">New York City</option>
            <option value="Seattle">Seattle</option>
            <option value="Chicago">Chicago</option>
            <option value="Ooty">Ooty</option>
            <option value="Bangalore">Bangalore</option>
            <option value="Los Angeles">Los Angeles</option>
            <option value="Chennai">Chennai</option>
            <option value="Mumbai">Mumbai</option>
            <option value="Delhi">Delhi</option>
            <option value="Tokyo">Tokyo</option>
            <option value="London">London</option>
            <option value="Paris">Paris</option>
            <option value="Berlin">Berlin</option>
            <option value="Milan">Milan</option>
            <option value="Genova">Genova</option>
          </select>

          <select
            className="select-country-box"
            value={selectDataType}
            style={{ marginLeft: "10px" }}
            onChange={(e) => setSelectDataType(e.target.value)}
          >
            <option value="admins">Admins</option>
            <option value="buildings">Buildings</option>
            <option value="places">Places</option>
            <option value="transportation">Transportation</option>
          </select>
          <button
            type="button"
            style={{
              marginBottom: "5px",
              marginLeft: "10px",
              color: "black",
            }}
            disabled={buttonTextDownload !== "Download"}
            onClick={(e) => handleDownloadingMapData(e)}
          >
            {buttonTextDownload}
          </button>
        </div>
        <div className="mapbox-show" ref={mapContainer} />
      </div>
    </div>
  );
}

export default MappingPage;
